import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import {
  IWithdraw,
  useCommunityWithdraws,
} from "../../store/useCommunityWithdraws";
import { useAuth } from "../../store/useAuth";

interface Props {
  communityId: string;
}

export const CommunityWithdrawTable = ({ communityId }: Props) => {
  /** Hooks */
  const { withdraws, deleteWithdraw } = useCommunityWithdraws();
  const { user } = useAuth();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              ID
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Amount
            </th>
            {user?.user_role === 1 ? (
              <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
                Actions
              </th>
            ) : null}
          </tr>
        </thead>
        <tbody>
          {withdraws?.length
            ? withdraws.map((withdraw: IWithdraw) => (
                <tr
                  key={withdraw?._id}
                  className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
                >
                  <td className="px-2 sm:px-6 py-1 sm:py-4 whitespace-nowrap">
                    {withdraw?._id}
                  </td>
                  <td className="px-2 sm:px-6 py-1 sm:py-4">
                    {Number(
                      (withdraw?.amount ? withdraw?.amount / 100 : 0)?.toFixed(
                        2
                      )
                    )}{" "}
                    €
                  </td>
                  {user?.user_role === 1 ? (
                    <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                      <TrashIcon
                        onClick={() => {
                          const confirmDelete = window.confirm(
                            "Are you sure you want to delete this withdraw?"
                          );
                          if (confirmDelete) {
                            deleteWithdraw(
                              withdraw?._id as string,
                              communityId
                            );
                          }
                        }}
                      />
                    </td>
                  ) : null}
                </tr>
              ))
            : null}
        </tbody>
      </table>
    </div>
  );
};
